// Central store to hold and manage state
import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

Vue.use(Vuex);

// Load cart from localStorage
let cart = [];
try {
  const storedCart = localStorage.getItem("sts_cart");
  if (storedCart) {
    cart = JSON.parse(storedCart);
  }
} catch (err) {
  console.error("Error loading cart from localStorage:", err);
}

export const store = new Vuex.Store({
  strict: false,
  state: {
    currentUser: {},
    currentPackage: {},
    isAuthenticated: false,
    sports: [],
    packages: [],
    categories: [],
    picks: [],
    editUser: {},
    selectedSport: "mlb",
    odds: {
      mlb: { live: {}, upcoming: {}, recent: {} },
      nba: { live: {}, upcoming: {}, recent: {} },
      ncaab: { live: {}, upcoming: {}, recent: {} },
      nba: { live: {}, upcoming: {}, recent: {} },
      nfl: { live: {}, upcoming: {}, recent: {} },
      mma: { live: {}, upcoming: {}, recent: {} },
      ncaaf: { live: {}, upcoming: {}, recent: {} },
    },
    // Shop state
    products: [],
    currentProduct: null,
    cart: cart,
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
});



// WEBPACK FOOTER //
// ./src/store/store.js